import { Shell } from '../ui/PwaContent';

export function GamesView() {
  return (
    <Shell title="Spiele" subtitle="Öffentlicher Bereich mit Mini-Games. Angemeldet gibt es später Highscores.">
      <div className="grid gap-4 md:grid-cols-3">
        {['Baderegel-Quiz', 'Rettungswurf Training', 'Flaggen Memory'].map((game) => (
          <article key={game} className="wwpwa-panel">
            <h2 className="font-bold">{game}</h2>
            <p className="mt-2 text-sm text-gray-600">Demo-Kachel. Später eigenes Feature-Modul.</p>
          </article>
        ))}
      </div>
    </Shell>
  );
}
